import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  cta: {
    id: `seo_client_error_cta`,
  },
  subtitle: {
    id: `seo_client_error_subtitle`,
  },
  title: {
    id: `seo_client_error_title`,
  },
});
